import {IVimeoVideoConfig} from './IVimeoVideo';

import {getAppOrigin} from '../../utils/url';
import {fetch} from '../../utils/utils';

import AbstractVideo from '../video/AbstractVideo';
import {TAspectRatioResponse} from '../video/IAbstractVideo';

/**
 * Represents VimeoVideo
 */
class VimeoVideo extends AbstractVideo{

	/**
	 * Constructor
	 * @constructor
	 * @param {IVimeoVideoConfig} config - config
	 */
	constructor(config: IVimeoVideoConfig) {
		super ({
			videoId: config.videoId,
			aspectRatio: config.aspectRatio,
			thumbnail: config.thumbnail,
		});
	}

	/**
	 * Returns the vimeo video url
	 * @returns {string}
	 */
	getVideoUrl(): string {
		return `https://player.vimeo.com/video/${this.videoId}`;
	}

	/**
	 * Returns the vimeo thumbnail url
	 * @param {object} dims - the dimensions to pass to Vimeo API
	 * @param {string} extension - the extension of the thumbnail image
	 * @returns {string}
	 */
	getThumbnailUrl(dims: Record<string, number> = {height: 0, width: 0}, extension?: string): string {
		if (this.thumbnail) {
			return this.thumbnail;
		}

		const {height = 0, width = 0} = dims;
		let url = `${getAppOrigin()}/mobify/vimeo-video/thumbnail?videoId=${this.videoId}`;

		if (height && width) {
			url += `&height=${height}&width=${width}`;
		}

		if (extension) {
			url += `&extension=${extension}`;
		}

		return url;
	}

	/**
	 * Returns the original dimensions of the video selected by id
	 * @param {string} id - the id of the video
	 * @returns {TOriginalDimensions}
	 */
	static async staticGetOriginalAspectRatio(id: string): Promise<TAspectRatioResponse> {
		return await fetch(`${getAppOrigin()}/mobify/vimeo-video/aspect-ratio?videoId=${id}`)
			.then((res) => (res as Response).json());
	}
}

export default VimeoVideo;
